// extracted by mini-css-extract-plugin
module.exports = {"readOnlyTable":"ReadOnlyTableData_readOnlyTable__3IaZL"};